import { css, styled } from 'styled-components';

const pointerStyles = css`
  border: 1px solid var(--color-text-alt);
  cursor: pointer;
  height: 12px;
  width: 12px;
`;

export const Wrapper = styled.div`
  & .react-colorful {
    margin-bottom: var(--spacing-medium);
    padding-bottom: 0;
    width: 100%;
  }

  /* stylelint-disable-next-line selector-class-pattern */
  & .react-colorful__saturation {
    border-bottom: 0;
    border-radius: 0;
    border-top-left-radius: var(--border-radius-big);
    border-top-right-radius: var(--border-radius-big);
  }

  /* stylelint-disable-next-line selector-class-pattern */
  & .react-colorful__pointer {
    ${pointerStyles}
  }

  /* stylelint-disable-next-line selector-class-pattern */
  & .react-colorful__hue {
    border-radius: 0;
    border-bottom-left-radius: var(--border-radius-big);
    border-bottom-right-radius: var(--border-radius-big);
  }

  /* stylelint-disable-next-line selector-class-pattern */
  & .react-colorful__hue-pointer {
    ${pointerStyles}
  }
`;
